document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('[data-hero-video]');

  console.log('video', video);

  if (video) {
    video.addEventListener('canplay', () => {
      video.play().catch(error => {
        console.log('Playback failed:', error);
      });

      video.classList.add('is-ready');
    });
  }
});